// noinspection DuplicatedCode

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Table from '@/modules/common/components/Table';
import TableContainer from '@/modules/common/components/TableContainer';
import { formatDateTime } from '~/common';

const Component = (props) => {
    const getClassName = (admin) => {
        let className = 'context-menu';
        if (props.selectedAdmin && props.selectedAdmin.id === admin.id) {
            className += ' selected';
        }
        return className;
    };

    // noinspection JSUnresolvedVariable
    return (
        <TableContainer>
            <Table>
                <TableHead><TableRow>
                    <TableCell>Имя пользователя</TableCell>
                    <TableCell className="last_login">Последний вход</TableCell>
                </TableRow></TableHead>
                <TableBody>
                    {props.admins.map((admin) => (
                        <TableRow key={admin.id} className={getClassName(admin)}
                                  onContextMenu={props.onContextMenu(admin)}
                        >
                            <TableCell>
                                <Link to={`/users/${admin.username}/`}>{admin.username}</Link>
                            </TableCell>
                            <TableCell className="last_login">
                                {(admin.last_login)
                                    ? <>{formatDateTime(new Date(admin.last_login))}</>
                                    : null
                                }
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

Component.propTypes = {
    admins: PropTypes.array.isRequired,
    selectedAdmin: PropTypes.object,
    onContextMenu: PropTypes.func.isRequired,
};

export default Component;
